import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useCardAttributeIdsByCards = (cardIds: string[] | undefined) : string[] | undefined => {
  const cardAttributeDb = useSelector((state: RootState) => state.cardAttributeDb);
  if (cardIds === undefined) return;
  let ids: string[] = [];
  cardIds.forEach(cardId => {
    const attributeIds = Object.keys(cardAttributeDb.cardAttributes).filter(id => cardAttributeDb.cardAttributes[id].cardId === cardId);
    ids.push(...attributeIds);
  })
  return ids;
}

export default useCardAttributeIdsByCards;
